<template>
  <div class="div">
    <div class="div-content">
      <el-card>
        <div style="width: 100%; padding: 10px">
          <el-row :gutter="10" style="margin: 0 auto; padding: 10px 0">
            <el-col :span="8">
              <span>年月：</span>
              <el-date-picker
                v-model="yearMonth"
                type="month"
                :clearable="false"
                value-format="yyyyMM"
                @change="yearMonthChange"
                placeholder="选择年月"
                style="width: 220px"
              >
              </el-date-picker>
            </el-col>
          </el-row>

          <el-row :gutter="10" style="margin: 0 auto">
            <el-col :span="8" v-loading="loading">
              <div class="dom-card">
                <div class="dom-card-title df aic jub">
                  <div>
                    <span>当前备件库存</span>
                    <el-radio-group
                      v-model="DataRadio"
                      class="title-card-button"
                      @change="getDataInfo"
                      style="margin-left: 10px"
                    >
                      <el-radio-button label="Amount">
                        <i class="icon icon-rmb1" style="font-size: 14px"></i>
                        金额</el-radio-button
                      >
                      <el-radio-button label="Qty">
                        <i class="icon icon-num" style="font-size: 14px"></i>
                        数量</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                  <div class="hint-text">
                    <span v-if="DataRadio === 'Amount'">单位：（元）</span>
                    <span v-if="DataRadio === 'Qty'">单位：（件）</span>
                  </div>
                </div>
                <div
                  class="df aic"
                  style="gap: 10px; height: 80px; margin-top: 10px"
                >
                  <div class="card-ba" style="width: 50%">
                    <div class="card-text">
                      <span class="bold-text">当前库存</span>
                    </div>
                    <div class="card-value">
                      <el-tooltip
                        v-if="DataRadio === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.tNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfo.tNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadio === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.tAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfo.tAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba df fww" style="width: 50%">
                    <div class="card-ba-cum">
                      <span>专用：</span>
                      <el-tooltip
                        v-if="DataRadio === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.czNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis val">
                          {{ $tools.formatThousand(dataInfo.czNum, 0) }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadio === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.czAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfo.czAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div class="card-ba-cum">
                      <span> 通用：</span>
                      <el-tooltip
                        v-if="DataRadio === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.ctNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfo.ctNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadio === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfo.ctAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfo.ctAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="echart-content">
                  <EchartsDom
                    type="pie"
                    :data="dataInfo.blist || []"
                    legendPosition="bottom"
                    title="库存分布"
                    style="width: 100%; height: 220px"
                    :showLegend="false"
                  ></EchartsDom>
                </div>
              </div>
            </el-col>
            <el-col :span="8" v-loading="loadingPut">
              <div class="dom-card">
                <div class="dom-card-title df aic jub">
                  <div>
                    <span>备件入库</span>
                    <el-radio-group
                      v-model="DataRadioPut"
                      class="title-card-button"
                      @change="getDataInfoPut"
                      style="margin-left: 10px"
                    >
                      <el-radio-button label="Amount">
                        <i class="icon icon-rmb1" style="font-size: 14px"></i>
                        金额</el-radio-button
                      >
                      <el-radio-button label="Qty">
                        <i class="icon icon-num" style="font-size: 14px"></i>
                        数量</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                  <div class="hint-text">
                    <span v-if="DataRadioPut === 'Amount'">单位：（元）</span>
                    <span v-if="DataRadioPut === 'Qty'">单位：（件）</span>
                  </div>
                </div>
                <div
                  class="df aic"
                  style="gap: 10px; height: 80px; margin-top: 10px"
                >
                  <div class="card-ba" style="width: 25%">
                    <div class="card-text">
                      <span class="bold-text">本年</span>
                    </div>
                    <div class="card-value">
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.sNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.sNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.sAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.sAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba df fww" style="width: 25%">
                    <div class="card-ba-cum">
                      <span> 专用：</span>
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.zNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.zNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.zAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.zAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div class="card-ba-cum">
                      <span> 通用：</span>
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.tNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.tNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.tAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.tAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba" style="width: 25%">
                    <div class="card-text">
                      <span class="bold-text">本月</span>
                    </div>
                    <div class="card-value">
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.cNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.cNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.cAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.cAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba df fww" style="width: 25%">
                    <div class="card-ba-cum">
                      <span> 专用：</span>
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.czNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.czNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="
                          $tools.formatThousand(dataInfoPut.czAmount, 2)
                        "
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.czAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div class="card-ba-cum">
                      <span> 通用：</span>
                      <el-tooltip
                        v-if="DataRadioPut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoPut.ctNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.ctNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioPut === 'Amount'"
                        effect="dark"
                        :content="
                          $tools.formatThousand(dataInfoPut.ctAmount, 2)
                        "
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoPut.ctAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="echart-content">
                  <EchartsDom
                    type="pie"
                    :data="dataInfoPut.blist || []"
                    legendPosition="bottom"
                    title="入库分布"
                    style="width: 100%; height: 220px"
                    :showLegend="false"
                  ></EchartsDom>
                </div>
              </div>
            </el-col>
            <el-col :span="8" v-loading="loadingOut">
              <div class="dom-card">
                <div class="dom-card-title df aic jub">
                  <div>
                    <span>备件出库</span>
                    <el-radio-group
                      v-model="DataRadioOut"
                      class="title-card-button"
                      @change="getDataInfoOut"
                      style="margin-left: 10px"
                    >
                      <el-radio-button label="Amount">
                        <i class="icon icon-rmb1" style="font-size: 14px"></i>
                        金额</el-radio-button
                      >
                      <el-radio-button label="Qty">
                        <i class="icon icon-num" style="font-size: 14px"></i>
                        数量</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                  <div class="hint-text">
                    <span v-if="DataRadioOut === 'Amount'">单位：（元）</span>
                    <span v-if="DataRadioOut === 'Qty'">单位：（件）</span>
                  </div>
                </div>
                <div
                  class="df aic"
                  style="gap: 10px; height: 80px; margin-top: 10px"
                >
                  <div class="card-ba" style="width: 25%">
                    <div class="card-text">
                      <span class="bold-text">本年</span>
                    </div>
                    <div class="card-value">
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.sNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.sNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.sAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.sAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba df fww" style="width: 25%">
                    <div class="card-ba-cum">
                      <span> 专用：</span>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.zNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.zNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.zAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.zAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div class="card-ba-cum">
                      <span> 通用：</span>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.tNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.tNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.tAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.tAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba" style="width: 25%">
                    <div class="card-text">
                      <span class="bold-text">本月</span>
                    </div>
                    <div class="card-value">
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.cNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.cNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.cAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.cAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="card-ba df fww" style="width: 25%">
                    <div class="card-ba-cum">
                      <span> 专用：</span>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.czNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.czNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="
                          $tools.formatThousand(dataInfoOut.czAmount, 2)
                        "
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.czAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div class="card-ba-cum">
                      <span> 通用：</span>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.ctNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.ctNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="
                          $tools.formatThousand(dataInfoOut.ctAmount, 2)
                        "
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.ctAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="echart-content">
                  <EchartsDom
                    type="pie"
                    :data="dataInfoOut.blist || []"
                    legendPosition="bottom"
                    title="出库分布"
                    style="width: 100%; height: 220px"
                    :showLegend="false"
                  ></EchartsDom>
                </div>
              </div>
              <!-- <div class="title-card" shadow="hover">
                <div class="title-t">
                  <div class="title-card-title">
                    <span>备件出库</span>
                    <el-radio-group
                      v-model="DataRadioOut"
                      class="title-card-button"
                      @change="getDataInfoOut"
                    >
                      <el-radio-button label="Amount">
                        <i class="icon icon-rmb1" style="font-size: 14px"></i>
                        金额</el-radio-button
                      >
                      <el-radio-button label="Qty">
                        <i class="icon icon-num" style="font-size: 14px"></i>
                        数量</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                </div>
                <div class="card-content">
                  <div class="card-c" style="border-radius: 0px 0px 0px 10px">
                    <div class="left">
                      <div>本年</div>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.sNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">
                          {{ $tools.formatThousand(dataInfoOut.sNum, 0) }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.sAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.sAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div
                      class="class-name"
                      style="width: 1px; background-color: #fff"
                    ></div>
                    <div class="right">
                      <div class="text">
                        <span> 专用：</span>
                        <el-tooltip
                          v-if="DataRadioOut === 'Qty'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.tNum, 0)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.zNum, 0)
                          }}</span>
                        </el-tooltip>
                        <el-tooltip
                          v-if="DataRadioOut === 'Amount'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.zAmount, 2)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.zAmount, 2)
                          }}</span>
                        </el-tooltip>
                      </div>
                      <div class="text">
                        <span> 通用：</span>
                        <el-tooltip
                          v-if="DataRadioOut === 'Qty'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.zNum, 0)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.tNum, 0)
                          }}</span>
                        </el-tooltip>
                        <el-tooltip
                          v-if="DataRadioOut === 'Amount'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.tAmount, 2)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.tAmount, 2)
                          }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div
                    class="class-name"
                    style="width: 1px; background-color: #fff"
                  ></div>
                  <div class="card-c" style="border-radius: 0px 0px 10px 0px">
                    <div class="left">
                      <div>本月</div>
                      <el-tooltip
                        v-if="DataRadioOut === 'Qty'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.cNum, 0)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.cNum, 0)
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        v-if="DataRadioOut === 'Amount'"
                        effect="dark"
                        :content="$tools.formatThousand(dataInfoOut.cAmount, 2)"
                        placement="top"
                      >
                        <span class="ellipsis">{{
                          $tools.formatThousand(dataInfoOut.cAmount, 2)
                        }}</span>
                      </el-tooltip>
                    </div>
                    <div
                      class="class-name"
                      style="width: 1px; background-color: #fff"
                    ></div>
                    <div class="right">
                      <div class="text">
                        <span> 专用：</span>
                        <el-tooltip
                          v-if="DataRadioOut === 'Qty'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.czNum, 0)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.czNum, 0)
                          }}</span>
                        </el-tooltip>
                        <el-tooltip
                          v-if="DataRadioOut === 'Amount'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.czAmount, 2)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.czAmount, 2)
                          }}</span>
                        </el-tooltip>
                      </div>
                      <div class="text">
                        <span> 通用：</span>
                        <el-tooltip
                          v-if="DataRadioOut === 'Qty'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.ctNum, 0)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.ctNum, 0)
                          }}</span>
                        </el-tooltip>
                        <el-tooltip
                          v-if="DataRadioOut === 'Amount'"
                          effect="dark"
                          :content="$tools.formatThousand(dataInfoOut.ctAmount, 2)"
                          placement="top"
                        >
                          <span class="ellipsis">{{
                            $tools.formatThousand(dataInfoOut.ctAmount, 2)
                          }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="echart-content">
                  <EchartsDom
                    type="pie"
                    :data="dataInfoOut.blist || []"
                    legendPosition="bottom"
                    title="出库分布"
                    :thousandSeparator="true"
                    :decimalPlaces="DataRadioOut === 'Qty' ? 0 : 2"
                    style="width: 100%; height: 220px"
                    :showLegend="false"
                  ></EchartsDom>
                </div>
              </div> -->
            </el-col>
          </el-row>
        </div>
      </el-card>
      <div class="wh100 dom-card" style="margin-top: 10px">
        <div class="dom-card-title">最新库存量</div>
        <el-table
          :data="tableData"
          style="width: 100%"
          height="calc(100% - 80px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="备件编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column label="备件名称" align="center" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="备件类型"
            align="center"
            prop="MaterialTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="备件规格" align="center" prop="Spec" sortable>
          </el-table-column>
          <el-table-column
            label="单位"
            align="center"
            prop="storageName"
            sortable
          >
          </el-table-column>
          <el-table-column label="库存数量" align="right" prop="Num" sortable>
          </el-table-column>
          <el-table-column
            label="货位"
            align="center"
            prop="LocalName"
            sortable
          >
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EchartsDom from '@/components/EchartsDom/EchartsDom.vue'
export default {
  data() {
    return {
      loading: false,
      searchData: {
        YearMonth: [
          moment().subtract(11, 'month').format('YYYYMM'),
          moment().format('YYYYMM'),
        ],
        BuildingId: [],
        BuildingInfo: [],
        DeviceType: [],
        DeviceTypeInfo: [],
      },
      InfoList: [],
      isData: false,
      dataInfo: {},
      DataRadio: 'Amount',
      dataInfoPut: {},
      DataRadioPut: 'Amount',
      DataRadioOut: 'Amount',
      loadingPut: false,
      loadingOut: false,
      dataInfoOut: {},

      selectedContents: [], // 新增用于存储选中的内容
      BuildingList: [],
      DeviceTypeList: [],
      yearMonth: moment().format('YYYYMM'),
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [10, 20, 40, 60, 100],
        total: 0,
      },
    }
  },
  props: {},
  components: { EchartsDom },
  methods: {
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getTableData()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getTableData()
    },
    getTableData() {
      this.$http
        .post('/IT/IT_LocalMaterial/GetSparesLedgerList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((res) => {
          if (res.Success) {
            this.tableData = res.Data
            this.pagination.total = res.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    yearMonthChange() {
      // this.getDataInfo()
      this.getDataInfoPut()
      this.getDataInfoOut()
    },

    getDataInfo() {
      this.loading = true
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryAnalysis?type=${this.DataRadio}`,
          {}
        )
        .then((res) => {
          this.loading = false

          if (res.Success) {
            this.dataInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    //入库
    getDataInfoPut() {
      this.loadingPut = true
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryInStorCurYearAnalysis?type=${this.DataRadioPut}&yearMonth=${this.yearMonth}`,
          {}
        )
        .then((res) => {
          this.loadingPut = false
          if (res.Success) {
            this.dataInfoPut = res.Data || {}
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    //出库
    getDataInfoOut() {
      this.loadingOut = true
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryOutStorCurYearAnalysis?type=${this.DataRadioOut}&yearMonth=${this.yearMonth}`,
          {}
        )
        .then((res) => {
          this.loadingOut = false
          if (res.Success) {
            this.dataInfoOut = res.Data || {}
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  mounted() {},
  created() {
    this.getDataInfo()
    this.getDataInfoPut()
    this.getDataInfoOut()
    this.getTableData()
    // this.getList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div {
  padding: 10px 20px;
}
.div-content {
  height: 100%;
  width: 100%;
  padding: 20px;
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
::v-deep .el-card__body {
  width: 100%;
  height: 100%;
  padding: 0;
}

.title-card-content {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.card-content {
  display: flex;
  height: 80px;
  width: 100%;
  padding: 0 10px;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    width: 100%;
    text-align: center;
  }
}
.echart-content {
  padding: 10px;
}
.title-t {
  width: 100%;
  padding: 0 10px;
}
.title-card-title {
  background: #28a745;
  color: #ffffff;

  border-bottom: 1px solid #ffffff;
  border-radius: 10px 10px 0 0;
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-c {
  display: flex;
  flex: 1;
  height: 80px;
  align-items: center;
  box-sizing: border-box;
  background: #28a745;
  border-radius: 0 0 10px 10px;
  position: relative;
  overflow: hidden;

  .left {
    width: 50%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    position: relative;
    z-index: 1;

    > div {
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 6px;
      opacity: 1;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    span {
      font-size: 22px;
      font-weight: 800;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      letter-spacing: 0.5px;
    }
  }

  .right {
    width: 50%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
    position: relative;
    z-index: 1;

    .text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      font-size: 13px;

      &:first-child {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        margin-bottom: 4px;
      }

      span:first-child {
        font-weight: 600;
        opacity: 1;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      span:last-child {
        font-weight: 700;
        font-size: 16px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        flex: 1;
        text-align: right;
      }
    }
  }
}

.com {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  span:first-child {
    display: inline-block;
    width: 60px;
    font-weight: 600;
    opacity: 1;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  span:last-child {
    display: inline-block;
    width: calc(100% - 60px);
    font-weight: 700;
    font-size: 16px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    flex: 1;
    text-align: right;
  }
}
.class-name {
  width: 1px;
  height: 100%;
  background: #ffffff;
}
</style>
